import { render, staticRenderFns } from "./manageAssets.vue?vue&type=template&id=72c3b17a&scoped=true"
import script from "./manageAssets.vue?vue&type=script&lang=js"
export * from "./manageAssets.vue?vue&type=script&lang=js"
import style0 from "./manageAssets.vue?vue&type=style&index=0&id=72c3b17a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@6.11.0_vue-template-compiler@2.7.16_webpack@5.104.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c3b17a",
  null
  
)

export default component.exports